import React, {PureComponent} from "react";
import PropTypes from 'prop-types'
import { Glyphicon } from "react-bootstrap";
import Input from "../../shared/components/auth/Input";
import ButtonLoader from "../../shared/components/auth/ButtonLoader/index";

class EmailSignInForm extends PureComponent {
  static propTypes = {
    signIn: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
  };

  static defaultProps = {
    isLoading: false,
  };

  state = {
    email: null,
    password: null
  }

  handleInput = (key, val) => {
    this.setState({[key]: val || null});
  }

  handleSubmit = (event) => {
    const formData = this.state;
    event.preventDefault();
    this.props.signIn(formData);
  }

  render () {
    const {isLoading} = this.props;
    const {email, password} = this.state;

    return (
      <form className='email-sign-in-form clearfix'
            onSubmit={this.handleSubmit}>
        <Input type="text"
               groupClassName="email-sign-in-email"
               label="Email"
               placeholder="Email"
               disabled={isLoading}
               value={email || ''}
               errors={[]}
               onChange={val => this.handleInput('email', val)}
        />

        <Input type="password"
               label="Password"
               groupClassName="email-sign-in-password"
               placeholder="Password"
               disabled={isLoading}
               value={password || ''}
               errors={[]}
               autoComplete="off"
               onChange={val => this.handleInput('password', val)}
        />

        <ButtonLoader loading={isLoading}
                      type="submit"
                      icon={<Glyphicon glyph="log-in"/>}
                      className='email-sign-in-submit pull-right'
                      disabled={isLoading}
                      onClick={this.handleSubmit}
        >
          Sign In
        </ButtonLoader>
      </form>
    );
  }
}

export default EmailSignInForm;



// WEBPACK FOOTER //
// ./src/auth/components/sign-in-form.js